import { Component, forwardRef, ElementRef, ViewChild } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
    selector: 'app-custom-color-selector',
    templateUrl: './custom-color-selector.component.html',
    styleUrls: ['./custom-color-selector.component.less'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => CustomColorSelectorComponent),
            multi: true
        }
    ]
})
export class CustomColorSelectorComponent implements ControlValueAccessor {
    @ViewChild('colorPicker') pickerElement: ElementRef;
    private propagateChange: (_: any) => {}

    writeValue(hex: string): void {
        this.pickerElement.nativeElement.setAttribute('value', '#' + hex);
    }

    registerOnChange(fn: any): void {
        this.propagateChange = fn;
    }

    registerOnTouched(fn: any): void {
        // throw new Error("Method not implemented.");
    }

    onChange(event) {
        this.propagateChange(event['target'].value.slice(1));
    }
}



// WEBPACK FOOTER //
// /home/runner/work/nomadic-admin/nomadic-admin/nomadic-admin/src/app/shared/custom-color-selector/custom-color-selector.component.ts